import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ConsentIntegrationOptions} from "../components/consentIntegrationSection/ConsentIntegrationSection";

export const getKlaviyoCallbackUrlToken = async (domain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `shop/klaviyo-callbackUrl`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
        isEncrypted: true,
    });
}